import React from "react";
import {Handle, Position} from "@xyflow/react";
import {EstateCardProps} from "../../EstateCard/EstateCard";

export type FirstLevelParentNodeProps = {
    height: number,
    width: number,
    headerLineText: string,
    firstLevelEstateCards: EstateCardProps[]
};

const FirstLevelParentNode = ({data}: { data: FirstLevelParentNodeProps }) => {
    return (
        <div className={"first-level-node"}>
            <Handle type={"source"} position={Position.Bottom}/>
        </div>
    );
}

export default FirstLevelParentNode;